import DocxViewer from "../components/DocxView/DocxView"

const index =()=>{
    return (
       <DocxViewer docxFile={'/static/word2.docx'}  ></DocxViewer>
    )
}
export default index